export const ExternalLinks = {
  privacyPolicy: 'https://i2iconnect.com/privacy-policy/',
  termsofservice: 'https://i2iconnect.com/terms-of-service/',
  mentalhealthImmediateHelp:
    'https://www.mentalhealth.gov/get-help/immediate-help',
  platformAndServicesAgreement:
    'https://i2iconnect.com/platform-services-agreement-t7kq3mrv9x',
};
